import {getField, updateField} from 'vuex-map-fields';
import ConsumerModule from '@/commonFunction/consumerModule'

let current_module = new ConsumerModule('/ws/product/product/');

const state = {
    ...current_module.state,
    columns: [
        {text: '', value: 'deleted', sortable: false, filterable: true, divider: true, width: 30},
        {text: '', value: 'edit', sortable: false, filterable: true, divider: true, width: 30},
        {text: 'Notion ID', value: 'notion_id', sortable: false, filterable: true, divider: true,},
        {text: 'Name*', value: 'name', sortable: true, filterable: true, divider: true,},
        {text: 'Ver.', value: 'version', sortable: false, filterable: false, divider: true,},
        {text: 'Prototype name', value: 'prototype_name', sortable: false, filterable: false, divider: true,},
        {text: 'Prototype ver.', value: 'prototype_version', sortable: false, filterable: false, divider: true,},
        {text: 'Status', value: 'status', sortable: true, filterable: true, divider: true,},
        {text: 'Customer', value: 'customer_name', sortable: true, filterable: true, divider: true,},

        {text: 'Created by', value: 'created_by_name', sortable: true, divider: true,},
        {text: 'Created on', value: 'created_on', sortable: true, divider: true, type: 'datetime',},
        {text: 'Edited by', value: 'edited_by_name', sortable: true, divider: true,},
        {text: 'Edited on', value: 'edited_on', sortable: true, divider: true, type: 'datetime',},
    ],
    options: {
        page: 1,
        itemsPerPage: 250,
        sortBy: ['name'],
        sortDesc: [false],
        multiSort: false,
        mustSort: false,
        descending: true,
    },
    filtersArg: {
        from_date: null,
        to_date: null,
    },
};

const getters = {
    ...current_module.getters,
    getColumns(state) {
        return state.columns
    },
};
const actions = {
    ...current_module.actions,
};
const mutations = {
    ...current_module.mutations,
};

export default {
    modules: {
        ProductTable: {
            namespaced: true,
            state,
            getters,
            actions,
            mutations
        }
    }
}